import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _68b0cca2 = () => interopDefault(import('..\\pages\\adcetris-landing.vue' /* webpackChunkName: "pages_adcetris-landing" */))
const _3e63c2a6 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _a815c134 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _022bbca4 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _17368db1 = () => interopDefault(import('..\\pages\\selection.vue' /* webpackChunkName: "pages_selection" */))
const _f7a9b97c = () => interopDefault(import('..\\pages\\tivdak-landing.vue' /* webpackChunkName: "pages_tivdak-landing" */))
const _b2539922 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _2142df8e = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _2150f70f = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _216d2611 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _217b3d92 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _56291acf = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _5976b013 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _c5efff12 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/adcetris-landing",
    component: _68b0cca2,
    name: "adcetris-landing"
  }, {
    path: "/error",
    component: _3e63c2a6,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _a815c134,
    name: "have-a-card"
  }, {
    path: "/rejection",
    component: _022bbca4,
    name: "rejection"
  }, {
    path: "/selection",
    component: _17368db1,
    name: "selection"
  }, {
    path: "/tivdak-landing",
    component: _f7a9b97c,
    name: "tivdak-landing"
  }, {
    path: "/unlock",
    component: _b2539922,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _2142df8e,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _2150f70f,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _216d2611,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _217b3d92,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _56291acf,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _5976b013,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _c5efff12,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
